import React, { useState } from 'react';
import styles from './css/TempestSocialMedia.module.css';
import boatOnFire from './assets/__BoatOnFire.png';
import profileBg from './assets/__ProfileBackground.png';
import profilePic from './assets/__ProfilePicture.png';
import fishmen from './assets/__fishmen.png';

const CHARACTERS = {
  antonio:  { name: 'Antonio',   initials: 'AN', color: '#5c3d99' },
  prospero: { name: 'Prospero',  initials: 'PR', color: '#1a3a5c' },
  miranda:  { name: 'Miranda',   initials: 'MI', color: '#c0392b' },
  ariel:    { name: 'Ariel',     initials: 'AR', color: '#27ae60' },
  noah:     { name: 'Noah T',    initials: 'NT', color: '#34495e' },
  caliban:  { name: 'Caliban',   initials: 'CA', color: '#7f6000' },
  gonzalo:  { name: 'Gonzalo',   initials: 'GO', color: '#2c7a7a' },
  alonso:   { name: 'Alonso',    initials: 'AL', color: '#8e44ad' },
  sebastian:{ name: 'Sebastian', initials: 'SE', color: '#c0392b' },
  trinculo: { name: 'Trinculo',  initials: 'TR', color: '#d35400' },
  stephano: { name: 'Stephano',  initials: 'ST', color: '#16a085' },
  ferdinand:{ name: 'Ferdinand', initials: 'FE', color: '#2980b9' },
};

const POSTS = [
  {
    id: 1,
    author: 'antonio',
    time: '12 years ago · Milan',
    text: 'Just made a very shrewd business decision. The Duchy of Milan is now under new management. 👔 Sometimes you have to take initiative when your brother spends too much time reading books instead of ruling. #NewOpportunities #Milan #Promotion #Hustle',
    reactions: { '👍': 3, '😆': 12, '😮': 7 },
    comments: [
      { author: 'gonzalo', text: "I want it noted that I personally ensured the exiled parties were given sufficient provisions. This is on record." },
      { author: 'noah', text: "Absolute legend move. Milan's gain is the open sea's loss 😂" },
      { author: 'sebastian', text: "Keep out of this Noah!! 😂" },
      { author: 'prospero', text: "..." },
      { author: 'antonio', text: "@Prospero don't be like that, it's called DELEGATION 😊" },
    ],
  },
  {
    id: 2,
    author: 'antonio',
    time: 'Tuesday · somewhere in the Mediterranean',
    text: "Not going to lie guys, this boat trip is NOT going as planned. Anyone else's ship currently on fire during a completely inexplicable storm? Asking for a friend. 🌊⛵🔥",
    image: boatOnFire,
    reactions: { '😂': 22, '😮': 44, '😢': 5 },
    comments: [
      { author: 'alonso', text: "MY SON. MY SON IS IN THE WATER. ANTONIO WHY ARE YOU POSTING ON SOCIAL MEDIA RIGHT NOW" },
      { author: 'sebastian', text: "Fully blaming the navigator tbh." },
      { author: 'gonzalo', text: "Rest assured I packed extra garments for all eventualities. We shall endure. The grass on yonder isle looks remarkably lush." },
      { author: 'trinculo', text: "same honestly same" },
    ],
  },
  {
    id: 3,
    author: 'antonio',
    time: 'Tuesday · some mysterious island, idk',
    text: "Good news: did not drown. Bad news: washed up on a mysterious tropical island with no WiFi. Silver lining — the beach is actually incredible. 🌴✨ Could be worse? #IslandLife #Stranded #NotDead",
    reactions: { '👍': 18, '❤️': 3, '😆': 9 },
    comments: [
      { author: 'gonzalo', text: "The turf here is indeed lush and green. The air is sweet. Providence hath brought us hither. I count this a blessing!" },
      { author: 'sebastian', text: "This is not how I wanted to spend my Tuesday." },
      { author: 'caliban', text: "GET OFF MY ISLAND. This is MY island. Prospero stole it from me and now YOU lot turn up?? Absolutely not." },
      { author: 'ariel', text: "👀" },
    ],
  },
  {
    id: 4,
    author: 'antonio',
    time: 'Tuesday, late · the island (still)',
    text: "Overheard King Alonso snoring like an absolute foghorn just now. Sleep well, Your Majesty… for now. 😏 Anyway. Just a thought. Nothing more. Simply an observation.",
    reactions: { '😏': 31, '😮': 2 },
    comments: [
      { author: 'sebastian', text: "Say less. 😏" },
      { author: 'gonzalo', text: "I am awake, actually. I never truly sleep. I am always watching. Just so we are all clear on that." },
      { author: 'ariel', text: "Hi! Just a quick note — I'm always here too. Invisible, obviously. But here. Always. Enjoy your evening! 😊" },
      { author: 'alonso', text: "I can see this notification. I am RIGHT HERE." },
    ],
  },
  {
    id: 5,
    author: 'antonio',
    time: 'Wednesday · the island',
    text: "UPDATE: have encountered what appears to be some sort of fish-man native to this island?? He has now attached himself to two shipwrecked drunk men as his new gods. Island life continues to be completely unhinged. 🐟🍷",
    image: fishmen,
    reactions: { '😆': 56, '😮': 14 },
    comments: [
      { author: 'caliban', text: "I am NOT a fish man. I am the TRUE lord of this island and my mother was a powerful witch and— actually, yes, Stephano's wine is incredible so I stand by my choices." },
      { author: 'trinculo', text: "he crawled under my cloak and I simply did not have the heart to say no. new best mate." },
      { author: 'stephano', text: "lads I think I might be king of this island now? the bar was admittedly not high. 👑" },
      { author: 'miranda', text: "Father are you seeing this feed?? These are the people you invited to our island??" },
    ],
  },
  {
    id: 6,
    author: 'antonio',
    time: 'Wednesday afternoon · the island',
    text: "A full magical banquet appeared out of absolutely nowhere — roast meats, bread, wine, the works — and then a HARPY materialised and made it literally vanish just as I reached for the bread rolls. I am genuinely having a day. 🍞✨😤",
    reactions: { '😢': 40, '😡': 8, '😆': 22 },
    comments: [
      { author: 'ariel', text: "😇 Hope you enjoyed the ambiance!" },
      { author: 'sebastian', text: "I HAD THE ROAST CHICKEN IN MY HAND. IT WAS IN MY ACTUAL HAND." },
      { author: 'gonzalo', text: "I had a terrible feeling about that table. The legs seemed too symmetrical. I said nothing. That was an error on my part." },
      { author: 'alonso', text: "The harpy said my name specifically. By name. In front of everyone. I need to lie down." },
    ],
  },
  {
    id: 7,
    author: 'antonio',
    time: 'Wednesday evening · awkward clearing, the island',
    text: "So. Prospero has been on this island THE ENTIRE TIME and apparently ORCHESTRATED EVERYTHING using a magic spirit he enslaved. The storm, the separation, the banquet — all him. Family reunions are so unbelievably awkward. 😬😬😬",
    reactions: { '😮': 88, '😂': 34, '😢': 12 },
    comments: [
      { author: 'prospero', text: "I forgive you, Antonio. Though you have wronged me most grievously, I choose mercy over vengeance. Now. My Dukedom, please." },
      { author: 'antonio', text: "..." },
      { author: 'miranda', text: "Father perhaps the dramatic monologue can wait five minutes. Just a thought." },
      { author: 'ferdinand', text: "I genuinely don't know anyone here. I've been here 3 hours. Miranda is lovely though. 10/10 island." },
      { author: 'caliban', text: "I am suddenly reassessing a significant number of my life choices. This is a lot." },
    ],
  },
  {
    id: 8,
    author: 'antonio',
    time: 'Wednesday night · heading home',
    text: "Setting sail back to Milan I suppose. Will update everyone when we're off the enchanted island. Still Duke btw. No further context at this time. 🚢",
    reactions: { '👍': 5, '😆': 71 },
    comments: [
      { author: 'prospero', text: "About that, Antonio." },
      { author: 'gonzalo', text: "All's well that ends well! (Wrong play, I know, but the sentiment applies beautifully here.)" },
      { author: 'alonso', text: "My son is alive. My son is alive!! Ferdinand is alive and engaged!! I am choosing joy today!!" },
      { author: 'ariel', text: "FREEDOM!! I'm free!! I'm actually free!! Goodbye everyone!! 🎉✨ [Ariel has left the chat]" },
      { author: 'caliban', text: "I will seek for grace. I mean it this time. Probably." },
    ],
  },
];

function Avatar({ charKey, size = 'md' }) {
  const char = CHARACTERS[charKey];
  return (
    <div
      className={`${styles.avatar} ${styles[`avatar_${size}`]}`}
      style={{ backgroundColor: char.color }}
    >
      {char.initials}
    </div>
  );
}

function ReactionBar({ reactions, postId }) {
  const [counts, setCounts] = useState({ ...reactions });
  const [userReaction, setUserReaction] = useState(null);

  const handleReact = (emoji) => {
    setCounts(prev => {
      const next = { ...prev };
      if (userReaction === emoji) {
        next[emoji] = Math.max(0, (next[emoji] || 0) - 1);
        setUserReaction(null);
      } else {
        if (userReaction) next[userReaction] = Math.max(0, (next[userReaction] || 0) - 1);
        next[emoji] = (next[emoji] || 0) + 1;
        setUserReaction(emoji);
      }
      return next;
    });
  };

  return (
    <div className={styles.reactionBar}>
      {Object.entries(counts).map(([emoji, count]) => (
        <button
          key={emoji}
          className={`${styles.reactionBtn} ${userReaction === emoji ? styles.reactionActive : ''}`}
          onClick={() => handleReact(emoji)}
        >
          <span>{emoji}</span>
          <span className={styles.reactionCount}>{count}</span>
        </button>
      ))}
    </div>
  );
}

function Comment({ comment }) {
  const char = CHARACTERS[comment.author];
  return (
    <div className={styles.comment}>
      <Avatar charKey={comment.author} size="sm" />
      <div className={styles.commentBubble}>
        <span className={styles.commentAuthor}>{char.name}</span>
        <span className={styles.commentText}>{comment.text}</span>
      </div>
    </div>
  );
}

function Post({ post }) {
  const [showComments, setShowComments] = useState(false);
  const author = CHARACTERS[post.author];

  return (
    <div className={styles.post}>
      <div className={styles.postHeader}>
        <Avatar charKey={post.author} size="md" />
        <div className={styles.postMeta}>
          <span className={styles.postAuthor}>{author.name}</span>
          <span className={styles.postTime}>{post.time}</span>
        </div>
      </div>
      <p className={styles.postText}>{post.text}</p>
      {post.image && (
        <img src={post.image} alt="Post attachment" className={styles.postImage} />
      )}
      <ReactionBar reactions={post.reactions} postId={post.id} />
      <div className={styles.postActions}>
        <button className={styles.actionBtn} onClick={() => setShowComments(v => !v)}>
          💬 {post.comments.length} Comment{post.comments.length !== 1 ? 's' : ''}
        </button>
        <button className={styles.actionBtn}>↗ Share</button>
      </div>
      {showComments && (
        <div className={styles.comments}>
          {post.comments.map((c, i) => (
            <Comment key={i} comment={c} />
          ))}
        </div>
      )}
    </div>
  );
}

function TempestSocialMedia() {
  return (
    <div className={styles.page}>
      {/* Top Nav Bar */}
      <header className={styles.topBar}>
        <div className={styles.topBarLeft}>
          <span className={styles.logo}>🏝 The Island Network</span>
        </div>
        <div className={styles.topBarCenter}>
          <input className={styles.searchBar} type="text" placeholder="Search The Island Network…" readOnly />
        </div>
        <div className={styles.topBarRight}>
          <Avatar charKey="antonio" size="sm" />
          <span className={styles.topBarName}>Antonio</span>
        </div>
      </header>

      <div className={styles.layout}>
        {/* Left Sidebar */}
        <aside className={styles.sidebar}>
          <div className={styles.profileCard}>
            <div className={styles.profileCover} style={{ backgroundImage: `url(${profileBg})` }} />
            <div className={styles.profileAvatarWrap}>
              <img src={profilePic} alt="Antonio" className={styles.profilePicture} />
            </div>
            <div className={styles.profileInfo}>
              <h2 className={styles.profileName}>Antonio</h2>
              <p className={styles.profileBio}>Duke of Milan (self-appointed). Entrepreneur. Smooth operator. Brother of Prospero (it's complicated). Currently: shipwrecked.</p>
            </div>
            <ul className={styles.profileDetails}>
              <li>🏙 Lives in <strong>Milan</strong></li>
              <li>🎓 School of Hard Knocks, Milan</li>
              <li>💼 Head of State (Milan)</li>
              <li>👥 <strong>3</strong> Friends (it's a small island)</li>
            </ul>
          </div>

          <div className={styles.sidePanel}>
            <h3 className={styles.sidePanelTitle}>People You May Know</h3>
            {['prospero','miranda','ariel','caliban','gonzalo'].map(k => (
              <div key={k} className={styles.friendSuggestion}>
                <Avatar charKey={k} size="sm" />
                <span className={styles.friendName}>{CHARACTERS[k].name}</span>
                <button className={styles.addFriendBtn}>+ Add</button>
              </div>
            ))}
          </div>
        </aside>

        {/* Main Feed */}
        <main className={styles.feed}>
          <div className={styles.storyBar}>
            <div className={styles.storyBarTitle}>📖 Antonio's Timeline — <em>The Tempest</em></div>
          </div>
          {POSTS.map(post => (
            <Post key={post.id} post={post} />
          ))}
        </main>

        {/* Right Sidebar */}
        <aside className={styles.rightSidebar}>
          <div className={styles.sidePanel}>
            <h3 className={styles.sidePanelTitle}>Island Trending</h3>
            <ul className={styles.trendList}>
              <li>#MagicSpellsUnleashed</li>
              <li>#WhoIsThatSpirit</li>
              <li>#CalibanWasRight</li>
              <li>#MirandaMeetsABoy</li>
              <li>#TheBanquetDisappeared</li>
              <li>#ForgiveOrRevenge</li>
              <li>#ArielIsFree</li>
            </ul>
          </div>
          <div className={styles.sidePanel}>
            <h3 className={styles.sidePanelTitle}>Online Now</h3>
            {['ariel','gonzalo','caliban','trinculo'].map(k => (
              <div key={k} className={styles.onlineUser}>
                <Avatar charKey={k} size="sm" />
                <span className={styles.friendName}>{CHARACTERS[k].name}</span>
                <span className={styles.onlineDot} />
              </div>
            ))}
          </div>
        </aside>
      </div>

      {/* Copyright */}
      <div className={styles.copyright}>
        &copy; {new Date().getFullYear()} Noah Thorpe. All rights reserved. &nbsp;·&nbsp; The Island Network is a fictional parody created for educational purposes. &nbsp;·&nbsp; Based on <em>The Tempest</em> by William Shakespeare.
      </div>

      {/* Banner Ad */}
      {/* <div className={styles.bannerAd}>
        <div className={styles.bannerAdLabel}>Sponsored</div>
        <div className={styles.bannerAdBody}>
          <div className={styles.bannerAdIcon}>🌊</div>
          <div className={styles.bannerAdContent}>
            <h4 className={styles.bannerAdTitle}>Prospero's Island Retreats</h4>
            <p className={styles.bannerAdText}>Escape the politics of mainland Italy. Exclusive enchanted island getaways. Spirits included. Magic lessons available. No prior experience required.</p>
            <p className={styles.bannerAdSub}>⚠️ Some guests have reported being stranded for 12+ years. Terms apply.</p>
            <button className={styles.bannerAdBtn}>Book Your Voyage →</button>
          </div>
        </div>
        <div className={styles.bannerAdFooter}>prospero-island-retreats.com · Not responsible for tempests, spells, or unsolicited exposure to classical drama.</div>
      </div> */}
    </div>
  );
}

export default TempestSocialMedia;
